import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const BOAT = {
  nickname: 'PRODUCTS.BOAT.nickname',
  properties: [
    { name: 'productSumInsured', key: 'SUM_INSURED', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.NUMBER,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'boatBuiltYear', key: 'BUILD_YEAR', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.DATE,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        dateView: 'multi-years'
      }
    },
    { name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_BOAT.3', value: '3000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_BOAT.5', value: '5000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_BOAT.7', value: '7000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_BOAT.10', value: '10000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_BOAT.15', value: '15000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_BOAT.20', value: '20000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_BOAT.25', value: '25000' }
        ]
      }
    },
    { name: 'boatMaxSpeed', key: 'BOAT_MAX_SPEED', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.10', value: '10' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.15', value: '15' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.20', value: '20' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.25', value: '25' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.30', value: '30' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.35', value: '35' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.40', value: '40' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.45', value: '45' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.50', value: '50' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.51', value: '51' },
        ]
      }
    },
    { name: 'boatHarborPermanentSecurity', key: 'HARBOR_PERMANENT_SECURITY', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'boatType', key: 'BOAT_TYPE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPE.INBOARD_ENGINE', value: 'INBOARD_ENGINE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPE.OUTBOARD_ENGINE', value: 'OUTBOARD_ENGINE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPE.SAILBOAT', value: 'SAILBOAT' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPE.ROWING_BOAT', value: 'ROWING_BOAT' },
          // { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPE.SAILING_BOARD', value: 'SAILING_BOARD' },
          // { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPE.CANOE', value: 'CANOE' },
          // { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPE.KAYAK', value: 'KAYAK' }
        ]
      }
    },
    { name: 'boatTheftProtection', key: 'BOAT_THEFT_PROTECTION', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_THEFT_PROTECTION.FG_ALARM', value: 'FG_ALARM' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_THEFT_PROTECTION.FG_SEARCH_SYSTEM', value: 'FG_SEARCH_SYSTEM' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_THEFT_PROTECTION.SECURMARK', value: 'SECURMARK' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_THEFT_PROTECTION.NO', value: 'NO' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_THEFT_PROTECTION.SNAP_OFF_STEERING_WHEEL', value: 'SNAP_OFF_STEERING_WHEEL' }
        ]
      }
    },
    { name: 'boatWinterStorage', key: 'BOAT_WINTER_STORAGE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_WINTER_STORAGE.UNKNOWN', value: 'UNKNOWN' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_WINTER_STORAGE.ON_WATER', value: 'ON_WATER' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_WINTER_STORAGE.OUTDOORS_15_11_15_3', value: 'OUTDOORS_15_11_15_3' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_WINTER_STORAGE.INDOORS_15_11_15_3', value: 'INDOORS_15_11_15_3' },
        ]
      }
    },
    { name: 'boatMemberOfRedningsforbundet', key: 'BOAT_MEMBER_OF_REDNINGSBUNDET', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'boatTrafficArea', key: 'BOAT_TRAFFIC_AREA', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TRAFFIC_AREA.NO_SVE_DK_SF', value: 'NO_SVE_DK_SF' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TRAFFIC_AREA.NORTH_SEA', value: 'NORTH_SEA' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TRAFFIC_AREA.LAKE_NORWAY', value: 'LAKE_NORWAY' },
        ]
      }
    },
    { name: 'boatRental', key: 'BOAT_RENTAL', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'zipCode', key: 'OBJECT_ZIP', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.required,
        Validators.pattern('[0-9]{4}$')
      ]],
      customProductTypeConfig: {
        BOAT: {
          key: 'OBJECT_ZIP_BOAT'
        }
      }
    },
    { name: 'productPackage', key: 'PRODUCT_PACKAGE', group: 'INSURANCE_INFO',
      validator: ['', [
        Validators.required
      ]],
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.ANSVAR', value: 'ANSVAR' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.DELKASKO', value: 'DELKASKO' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.KASKO', value: 'KASKO' },
        ]
      }
    },
    { name: 'vehicleLicenseNumber', key: 'LICENSE_NUMBER', group: 'OBJECT_INFO' },
    { name: 'boatHarborLocation', key: 'HARBOR_LOCATION', group: 'INSURANCE_INFO' },
    { name: 'boatSecurityHasSecurmark', key: 'SECURITY_HAS_SECUREMARK', group: 'INSURANCE_INFO' },
    { name: 'boatLength', key: 'BOAT_LENGTH', group: 'OBJECT_INFO' },
    { name: 'boatEngineHP', key: 'BOAT_ENGINE_HP', group: 'OBJECT_INFO' },
    { name: 'boatName', key: 'BOAT_NAME', group: 'OBJECT_INFO' },
    { name: 'boatMotorMake', key: 'BOAT_MOTOR_MAKE', group: 'OBJECT_INFO' },
    { name: 'calculatedClientAge', key: 'CLIENT_AGE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.required,
        Validators.pattern(/^\d+$/)
      ]]
    },
  ],
  icon:'boat'
};
